import ProjectSession from "../../../../../core/model2/project/project-session"
import {DraggedOverPosition} from "../../../../../core/gd-modules/dnd/@types"

// menu scoped copies of CUSTOM_DRAG_LAYER_* - the tasks-view table listens on those globally and its
// payload carries an ItemModelV2, so reusing them would cross the two trees' hover state
export const MENU_PROJECTS_DND_HOVER        = 'menu-projects-dnd:hover'
export const MENU_PROJECTS_DND_DRAGGED_OUT  = 'menu-projects-dnd:dragged-out'

export type MenuProjectsDndHoverParams = {
    project         : ProjectSession    // the row whose drop rect is hovered - NOT necessarily the future parent, see target
    draggedOver?    : DraggedOverPosition

    // decided by the handler so the rule for "between vs into" lives in exactly one place
    isDropInto?     : boolean

    // the project that will actually become the dragged item's parent if dropped right now - project
    // itself for an into-drop, but project's own parent for a between-rows reorder (neither flanking
    // row becomes the parent, their shared parent does)
    target?         : ProjectSession

    // whether the preview should render target - false when the drop would not change the parent
    showTarget?     : boolean
}

export type MenuProjectDropResult = {
    targetProject       : ProjectSession
    type?               : DraggedOverPosition

    // the sibling list the target was rendered in - reordering needs it, and only the target
    // knows it (onDrop runs on the target, onDragEnd on the source)
    targetParentId?     : ID
    targetSiblings?     : ProjectSession[]

    isDropInto?         : boolean
    isReorder?          : boolean
}
